exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "ul._2GvAk-JBaxUsD3ebmSv8AH{margin:0 0}ul._2GvAk-JBaxUsD3ebmSv8AH li:hover{border-top:1px solid #eee;margin:-1px -20px 0 -20px;padding:7px 20px 7px 20px}\n", ""]);

// Exports
exports.locals = {
	"FullBleedList": "_2GvAk-JBaxUsD3ebmSv8AH"
};